import { render, staticRenderFns } from "./WPViewer.vue?vue&type=template&id=9281512a&scoped=true&"
import script from "./WPViewer.vue?vue&type=script&lang=js&"
export * from "./WPViewer.vue?vue&type=script&lang=js&"
import style0 from "./WPViewer.vue?vue&type=style&index=0&id=9281512a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9281512a",
  null
  
)

export default component.exports